// LOCAL
// export const API_CONFIG = {
//   baseURL: process.env.EXPO_PUBLIC_API_BASE_URL ?? 'https://soc-alpha-api.sociants.com/api',
//   seliBaseURL: process.env.EXPO_PUBLIC_SELI_BASE_URL ?? 'https://seli-alpha.sociants.com',
//   sociantBaseURL: process.env.EXPO_PUBLIC_SOCIANT_BASE_URL ?? 'https://soc-alpha-api.sociants.com',
//   timeout: 30000, // 30 seconds
// };

// DEMO
export const API_CONFIG = {
  baseURL: process.env.EXPO_PUBLIC_API_BASE_URL ?? 'https://soc-demo-api.sociants.com/api',
  seliBaseURL: process.env.EXPO_PUBLIC_SELI_BASE_URL ?? 'https://seli-demo.sociants.com',
  sociantBaseURL: process.env.EXPO_PUBLIC_SOCIANT_BASE_URL ?? 'https://soc-demo-api.sociants.com',
  timeout: 30000, // 30 seconds
};

// BETA
// export const API_CONFIG = {
//   baseURL: process.env.EXPO_PUBLIC_API_BASE_URL ?? 'https://soc-alpha-api.sociants.com/api',
//   seliBaseURL: process.env.EXPO_PUBLIC_SELI_BASE_URL ?? 'https://seli-alpha.sociants.com',
//   sociantBaseURL: process.env.EXPO_PUBLIC_SOCIANT_BASE_URL ?? 'https://soc-alpha-api.sociants.com',
//   timeout: 30000, // 30 seconds
// };

